<template>
  <li :class="{ 'open': isOpen }">
    <div class="heading ut-flex ga-event" :data-category="gacategory" :class="{ 'disabled': !isOpenable }" @click="toggle()">
      <div class="ut-ml-0 ut-pl-1"><slot name="title"></slot></div>
      <div class="ut-block ut-mr-0 ga-event" :data-category="gacategory" :data-eventlabel="gaeventlabel"
        :class="{
          'toggle-icon': isOpenable,
          'ut-circle-img': isOpenable,
          'toggle-pluse': !isOpen && isOpenable,
          'toggle-minus' : isOpen && isOpenable
        }"></div>
    </div>
    <div class="body ut-container-sm" v-show="isOpen">
        <slot name="body"></slot>
    </div>
  </li>
</template>

<script>

export default {
  name: 'AccordianItem',
  props: {
    accordianItem: { required: false },
    isOpenable: { default: true },
    isOpen: { default: true },
    name: { default: null },
    gacategory: { default: null },
    gaeventlabel: { default: null },
  },
  data() {
    return {
      isOpenTest: false,
    };
  },
  methods: {
    toggle() {
      if (this.isOpenable) {
        this.$emit('click-header', { state: this.isOpen, name: this.name });
      }
    },
  },
  setClass() {
    return (this.accordianItem.isOpen === true) ? 'open' : 'close';
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    li {
      @apply ut-bg-neutral-001 ut-mb-2 ut-relative;
      border-top: 1px solid #E3E5E8;
      border-bottom: 1px solid #E3E5E8;

      @screen sm {
        border-radius: 6px;
        border: 1px solid #E3E5E8;
      }

      .heading {
        @apply ut-p-6 ut-text-green-400 ut-cursor-pointer;

        .toggle-icon {
          @apply ut-border ut-border-green-400;
          width: 21px;
          height: 21px;
          text-align: center;
          @apply ut-text-green-400;
          font-size: 20px;
          line-height: 16px;

          &.toggle-pluse::before{
              content: '+';
          }

          &.toggle-minus::before {
              content: '-';
          }

        }
      }

      .body {
          @apply ut-p-6;
      }

      &.open {
        box-shadow: 0 27px 70px -9px rgba(0,0,0,0.24), 0 1px 4px 1px rgba(0,0,0,0.11);

        .heading {
          @apply ut-font-bold;
        }
      }
    }

</style>
